module.exports = __webpack_public_path__ + "img/ic_klong.cfd6198a.svg";